import React, { FC } from 'react';
import noop from 'lodash/fp/noop';
import path from 'lodash/fp/path';
import { Box, CircularProgress, Tooltip, useTheme } from '@mui/material';
import PersonPinRounded from '@mui/icons-material/PersonPinRounded';

import { CapturePiece } from '@components/Capture/types';

import { CommonStyles, sxMR0, StyledIcon } from './styles';
import { getPieceDetection, getUserColorPieceStatus, tooltips } from '@components/Capture/helper';

interface IPersonPinRoundedProps {
  capturePiece: CapturePiece | null
  onClick?: () => void
}

const PersonPinRoundedIcon: FC<IPersonPinRoundedProps> = ({ capturePiece, onClick }) => {
  const theme = useTheme();
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;
  const isUserLoading =
    !!piece &&
    (capturePiece.isUpdating ||
      !(piece.recipient || capturePiece.pieceDetection || capturePiece.status === 'loadedFromServer'));

  const pieceDetection = getPieceDetection(capturePiece);
  const color = isUserLoading ? undefined : getUserColorPieceStatus(piece, pieceDetection?.status);
  const themeColor = color ? path(['palette', color, 'main'], theme) : undefined;

  return (
    <Box onClick={!piece ? noop : onClick} sx={{ ...CommonStyles, ...sxMR0 }}>
      <Tooltip title={tooltips[isUserLoading ? 'PersonPinRoundedLoading' : 'PersonPinRounded']} arrow>
        <PersonPinRounded sx={StyledIcon(!piece ? 'action.disabled' : themeColor)} />
      </Tooltip>
      {isUserLoading && <CircularProgress />}
    </Box>
  )
}

export { PersonPinRoundedIcon };
